import BaseApi from '@/api/base-api'

class MerchantSupportApi extends BaseApi {
  submitCallbackRequest = (data) => {
    return this.request({
      method: 'POST',
      path: this.uri + `/${data.merchantId}/submit-callback-request`,
      data: {
        country_code: data.countryCode,
        phone_number: data.phoneNumber?.replace(/^0/, ''),
        inquiry_type: data.inquiryAbout,
        inquiry_reason: 'Request for consultation call',
      },
    })
  }
}

export default new MerchantSupportApi('/merchant/support')
